import * as React from 'react';

import { Button } from '@coursera/cds-core';

import SetupPartnerModal from 'bundles/author-partner/components/setup-partner/SetupPartnerModal';

import _t from 'i18n!nls/admin';

type State = {
  showModal: boolean;
};

class CreateNewPartner extends React.Component<{}, State> {
  state = {
    showModal: false,
  };

  handleCancel = () => {
    this.setState({
      showModal: false,
    });
  };

  createNewPartnerStart = () => {
    this.setState({
      showModal: true,
    });
  };

  render() {
    const { showModal } = this.state;

    return (
      <div>
        <Button variant="primary" size="small" onClick={this.createNewPartnerStart}>
          {_t('+ Create Institution (SU Only)')}
        </Button>

        {showModal && <SetupPartnerModal onCancel={this.handleCancel} />}
      </div>
    );
  }
}

export default CreateNewPartner;
